import { Ability, AbilityBuilder } from '@casl/ability';
import { isBatEmployee } from '../utils/roles';

const subjectName = (item) => {
  if (!item || typeof item === 'string') {
    return item;
  }
  return item.__type;
};

export const defineRulesFor = (auth) => {
  const { can, rules } = new AbilityBuilder();
  if (isBatEmployee(auth)) {
    return rules;
  }
  if (auth.role !== 'driver') {
    can('view', 'tasks');
  }
  if (auth.role !== 'driver' && auth.role !== 'placer') {
    can('view', 'reports');
  }

  return rules;
};

export const ability = new Ability([], { subjectName });
